// @ts-nocheck

(function () {
  "use strict";

  const KEY = "breadcrumb_path";
  const path = window.location.pathname;

  if (path === "/" || path === "") {
    sessionStorage.removeItem(KEY);
    return;
  }

  if (!path.includes("/collections/") || path.includes("/products/")) return;

  const match = path.match(/\/collections\/([^\/\?#]+)/);
  if (!match) return;

  const handle = match[1];

  function getCollectionTitle() {
    const collectionTitleEl = document.querySelector(".ud-collection-title");
    if (collectionTitleEl) {
      const title = collectionTitleEl.textContent?.trim();
      if (title && title.length > 0) return title;
    }

    const h1 = document.querySelector("h1");
    if (h1) {
      const title = h1.textContent?.trim();
      if (title && title.length > 0 && title.toLowerCase() !== "collections") return title;
    }

    const breadcrumbCurrent = document.querySelector(".breadcrumbs__current");
    if (breadcrumbCurrent) {
      const title = breadcrumbCurrent.textContent?.trim();
      if (title && title.length > 0) return title;
    }

    return handle.replace(/-/g, " ");
  }

  function updateStoredTitle(collectionHandle, newTitle) {
    try {
      let history = JSON.parse(sessionStorage.getItem(KEY) || "[]");
      if (!Array.isArray(history)) return;

      let updated = false;
      history = history.map((item) => {
        if (item.handle === collectionHandle && item.title !== newTitle) {
          updated = true;
          return { ...item, title: newTitle };
        }
        return item;
      });

      if (updated) {
        sessionStorage.setItem(KEY, JSON.stringify(history));
      }
    } catch (e) {}
  }

  function save() {
    try {
      if (!handle) return;

      let title = getCollectionTitle();
      if (!title || typeof title !== "string" || title.trim().length === 0) {
        title = handle.replace(/-/g, " ");
      }

      const url = "/collections/" + handle;

      const wrapper = document.querySelector(".ud-collection-wrapper[parent-collection]");
      let parentHandle = null;
      if (wrapper) {
        const parentUrl = wrapper.getAttribute("parent-collection");
        if (parentUrl) {
          const parentMatch = parentUrl.match(/\/collections\/([^\/\?#]+)/);
          parentHandle = parentMatch ? parentMatch[1] : null;
        }
      }

      let history = [];
      try {
        history = JSON.parse(sessionStorage.getItem(KEY) || "[]");
        if (!Array.isArray(history)) history = [];
      } catch (e) {
        history = [];
      }

      history = history.filter((item) => item.handle !== handle);

      if (!parentHandle) {
        history = history.filter((item) => {
          return !item.parentHandle || item.parentHandle !== handle;
        });
      }

      if (parentHandle && history.length > 0) {
        const parentInHistory = history.find((item) => item.handle === parentHandle);
        if (parentInHistory) {
        } else if (history.length === 1) {
        }
      }

      const collectionData = { handle, title: title.trim(), url, parentHandle };
      history.push(collectionData);

      if (history.length > 2) {
        if (history.length === 3) {
          const [first, second, third] = history;
          if (third.parentHandle === second.handle) {
            history = [second, third];
          } else if (third.parentHandle === first.handle) {
            history = [first, third];
          } else {
            history = [second, third];
          }
        } else {
          history = history.slice(-2);
        }
      }

      sessionStorage.setItem(KEY, JSON.stringify(history));
    } catch (e) {}
  }

  function saveWithRetry() {
    save();

    const fallbackTitle = handle.replace(/-/g, " ");
    let resolved = false;
    const retryDelays = [100, 300, 500, 1000];

    retryDelays.forEach((delay) => {
      setTimeout(() => {
        if (resolved) return;

        const title = getCollectionTitle();
        if (title && title !== fallbackTitle) {
          resolved = true;
          updateStoredTitle(handle, title);

          try {
            const history = JSON.parse(sessionStorage.getItem(KEY) || "[]");
            if (Array.isArray(history)) {
              const currentItem = history.find((item) => item.handle === handle);
              if (currentItem && currentItem.parentHandle) {
                const breadcrumbLinks = document.querySelectorAll(".breadcrumbs__link");
                breadcrumbLinks.forEach((link) => {
                  const linkUrl = link.getAttribute("href");
                  if (linkUrl && linkUrl.includes("/collections/")) {
                    const linkMatch = linkUrl.match(/\/collections\/([^\/\?#]+)/);
                    if (linkMatch && linkMatch[1] === currentItem.parentHandle) {
                      const parentTitle = link.textContent?.trim();
                      if (parentTitle && parentTitle.length > 0) {
                        updateStoredTitle(currentItem.parentHandle, parentTitle);
                      }
                    }
                  }
                });
              }
            }
          } catch (e) {}
        }
      }, delay);
    });
  }

  function setupTitleObserver() {
    const fallbackTitle = handle.replace(/-/g, " ");
    const observer = new MutationObserver(() => {
      const title = getCollectionTitle();
      if (title && title !== fallbackTitle) {
        updateStoredTitle(handle, title);
        observer.disconnect();
      }
    });

    // Observe only the elements that could contain the collection title
    const targets = [
      document.querySelector(".ud-collection-title"),
      document.querySelector("h1"),
      document.querySelector(".breadcrumbs__current"),
    ].filter(Boolean);

    if (targets.length > 0) {
      targets.forEach((target) => {
        observer.observe(target.parentElement || target, {
          childList: true,
          subtree: true,
          characterData: true,
        });
      });
    } else {
      // Fallback: if none of the target elements exist yet, observe body briefly
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    setTimeout(() => observer.disconnect(), 5000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      saveWithRetry();
      setupTitleObserver();
    });
  } else {
    saveWithRetry();
    setupTitleObserver();
  }
})();
